import { useContext, useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME } from '../../campaignFormStepOne.constants';
import CommissionField from '../formFields/commissionField/commissionField';
import DeliveryCompanyField from '../formFields/deliveryCompanyField/deliveryCompanyField';
import DescriptionField from '../formFields/descriptionField/descriptionField';
import InspectionField from '../formFields/InspectionField/InspectionField';
import PeriodFields from '../formFields/periodFields/periodFields';
import ProductsField from '../formFields/productsField/productsField';
import CampaignFormStepButtons from '../../../../../campaignFormStepButtons/campaignFormStepButtons';
import { CampaignFormContext } from '../../../../../../../../campaignForm.context';
import { CampaignFormStepOneContext } from '../../campaignFormStepOne.context';
import { isKoreaService } from 'constants/domains/domains';

const BeautyCampaignFormStepOne = () => {
  const {
    brand,
    campaignFormMethods,
    setStep,
    checkedInspectionAgreement,
    updateCampaignId,
    storeOrUpdateTemporaryCampaignMutate,
    showLoader,
    setShowLoader,
  } = useContext(CampaignFormContext);
  const { isFormValid, getStepOneCampaignFormValues } = useContext(
    CampaignFormStepOneContext,
  );

  const [inspectionSubmitDueDt, inspectionFeedbackDueDt, commissionAmount] = useWatch({
    control: campaignFormMethods.control,
    name: ['inspectionSubmitDueDt', 'inspectionFeedbackDueDt', 'commissionAmount'],
  });

  const formFieldComponents = useMemo(() => {
    return [
      ...(!brand.isWholesale
        ? [CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.BRAND_DESCRIPTION]
        : []),
      CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.PRODUCT,
      CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.COMMISSION_AMOUNT,
      CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.INSPECTION_AGREEMENT,
      CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.PERIOD,
      CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.DELIVERY_COMPANY,
    ];
  }, [brand?.isWholesale]);

  const isValidNextButton = useMemo(() => {
    if (
      !isFormValid ||
      // 사전 검수 동의 했지만 영상 제출 날짜가 없는 경우
      (checkedInspectionAgreement && (!inspectionSubmitDueDt || !inspectionFeedbackDueDt)) ||
      // 수수료가 없는 경우
      !commissionAmount
    ) {
      return false;
    } else {
      return true;
    }
  }, [
    brand,
    isFormValid,
    checkedInspectionAgreement,
    inspectionSubmitDueDt,
    inspectionFeedbackDueDt,
    commissionAmount,
  ]);

  const onClickNext = () => {
    if (!showLoader) {
      if (updateCampaignId) {
        setStep((prevStep) => prevStep + 1);
      } else {
        setShowLoader(true);
        storeOrUpdateTemporaryCampaignMutate({
          campaign: getStepOneCampaignFormValues({
            fieldNames: [
              'description',
              'commissionAmount',
              'commissionIncreaseMaxStep',
              'inspectionSubmitDueDt',
              'inspectionFeedbackDueDt',
            ],
          }),
          options: {
            onSuccess: () => {
              setStep((prevStep) => prevStep + 1);
            },
          },
        });
      }
    }
  };

   

  return (
    <>
      {formFieldComponents.map((formFieldType, index) => {
        const key = `beauty-campaign-form-step-one-form-filed-${index}`;
        const elementIndex = index + 1;

        switch (formFieldType) {
          // 브랜드 한 문장 소개
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.BRAND_DESCRIPTION: {
            return <DescriptionField key={key} elementIndex={elementIndex} />;
          }
          // 제품 정보
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.PRODUCT: {
            return <ProductsField key={key} elementIndex={elementIndex} />;
          }
          // 원고료 설정
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.COMMISSION_AMOUNT: {
            return <CommissionField key={key} elementIndex={elementIndex} />;
          }
          // 사전 검수
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.INSPECTION_AGREEMENT: {
            return <InspectionField key={key} elementIndex={elementIndex} />;
          }
          // 캠페인 기간
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.PERIOD: {
            return <PeriodFields key={key} elementIndex={elementIndex} />;
          }
          // 이용 예정 택배사
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.DELIVERY_COMPANY: {
            return (
              <DeliveryCompanyField key={key} elementIndex={elementIndex} />
            );
          }
        }
      })}

      <CampaignFormStepButtons
        disabledNextButton={!isValidNextButton}
        onClickNext={onClickNext}
      />
    </>
  );
};

export default BeautyCampaignFormStepOne;
